import { AODA } from '@core/utilities/aoda';
import { Component, ElementRef, Injector, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { Publication } from '@shared/models/records/publication.model';
import { environment } from '@environments/environment';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';

@Component({
  selector: 'app-publication-result-card',
  templateUrl: './publication-result-card.component.html',
  styleUrls: ['./publication-result-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PublicationResultCardComponent extends BaseComponent implements OnInit, OnDestroy {

    @Input() record: any;
    @Input() searchTerm: string;
    searchTerms: string;
    isSingleClick: Boolean = true;     

    constructor(
        private injector: Injector,
        private route: ActivatedRoute,
        private el: ElementRef,
        private r2: Renderer2) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.record = new Publication(this.record._source);
        this.searchTerms = this.searchTerm;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngAfterViewInit(): void {
        AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
    }

    get publicationNumber() {
        return this.record.publ_num;
    }

    get title() {
        return this.record.title;
    }

    get contributors(): any[] {
        return this.record.contributors.sort((a, b) => (a.seniority > b.seniority ? 1 : -1));
    }

    get townships(): any[] {
        return this.record.townships;
    }

    get publishingYear(): string {
        return this.record.year.toString();
    }
    
    get nts(): any[] {
        return this.record.nts;
    }

    get updatedDate() {
        return this.record.updated_at;
    }

    openInSameTab() {
        this.isSingleClick = true;
        setTimeout(()=>{
            if(this.isSingleClick){
                this.router.navigate(['/publication', this.publicationNumber], { state: { data: this.record, searchTerms: this.searchTerms} });
            }
        }, 250)
    }

    openInNewTab() {
        this.isSingleClick = false;
        var target = environment.application_url + "persistent-linking?" + DatabaseIndexNameType.publication + "=" + this.publicationNumber;
        this.router.navigate([], { state: { data: this.record, searchTerms: this.searchTerms} }).then(() => {  window.open(target, '_blank'); });
    }

}